

































































































import { Component, Watch } from "vue-property-decorator";
import WindowVue from "@/app/core/window/WindowVue";
import { Mixins } from "vue-mixin-decorator";
import { ClientRoomInfo, UserType } from "@/@types/socket";
import LifeCycle from "@/app/core/decorator/LifeCycle";
import GameObjectManager from "@/app/basic/GameObjectManager";
import { StoreUseData } from "@/@types/store";
import { UserData } from "@/@types/room";
import { execCopy } from "@/app/core/utility/Utility";
import VueEvent from "@/app/core/decorator/VueEvent";
import BcdiceManager from "@/app/core/api/bcdice/BcdiceManager";
import SocketFacade from "@/app/core/api/app-server/SocketFacade";
import BaseInput from "@/app/core/component/BaseInput.vue";
import CtrlButton from "@/app/core/component/CtrlButton.vue";

@Component({
  components: {
    CtrlButton,
    BaseInput
  }
})
export default class RoomInfoWindow extends Mixins<WindowVue<never, never>>(
  WindowVue
) {
  private clientRoomInfo: ClientRoomInfo | null = null;
  private userList: StoreUseData<UserData>[] =
    GameObjectManager.instance.userList;
  private systemId: string | null = null;
  private systemName: string | null = null;

  @Watch("clientRoomInfo", { deep: true })
  private async onChangeClientRoomInfo() {
    this.systemId = this.clientRoomInfo ? this.clientRoomInfo.system : null;
  }

  @Watch("systemId")
  private async onChangeSystemId() {
    this.systemName = await BcdiceManager.getBcdiceSystemName(
      SocketFacade.instance.connectInfo.bcdiceServer,
      this.systemId
    );
  }

  private get useUserList(): StoreUseData<UserData>[] {
    const typeOrder: UserType[] = ["VISITOR", "PL", "GM"];
    return this.userList.concat().sort((u1, u2) => {
      const u1Index = typeOrder.findIndex(t => t === u1.data!.type);
      const u2Index = typeOrder.findIndex(t => t === u2.data!.type);
      if (u1Index < u2Index) return 1;
      if (u1Index > u2Index) return -1;
      if (u1.order < u2.order) return 1;
      if (u1.order > u2.order) return -1;
      return 0;
    });
  }

  public getInviteUrl(user?: StoreUseData<UserData>) {
    if (!this.clientRoomInfo) return "";
    const roomNo = this.clientRoomInfo.roomNo;
    const name = user ? user.data!.name : "";

    const baseUrl = location.href.replace(/\?.+$/, "");
    const params = new URLSearchParams();
    params.append("no", roomNo.toString(10));
    if (name) params.append("player", name);
    return `${baseUrl}?${params.toString()}`;
  }

  @VueEvent
  private copyToClipboard(text: string) {
    execCopy(text);
  }

  @LifeCycle
  public async mounted() {
    await this.init();
    this.clientRoomInfo = GameObjectManager.instance.clientRoomInfo;
    SocketFacade.instance.connectInfo.bcdiceServer;

    const declareObj = this.windowInfo.declare;

    const heightEm = this.userList.length * 2 + 12;
    this.windowInfo.heightEm = heightEm;
    declareObj.size.heightEm = heightEm;
    declareObj.minSize!.heightEm = heightEm;
    declareObj.maxSize!.heightEm = heightEm;

    const heightPx = this.userList.length + 3;
    this.windowInfo.heightPx = heightPx;
    declareObj.size.heightPx = heightPx;
    declareObj.minSize!.heightPx = heightPx;
    declareObj.maxSize!.heightPx = heightPx;
  }

  @VueEvent
  private modify() {
    alert("modify");
  }
}
